/**
 * User levels are a closed enum (User.USER_ACCESS_RIGHTS), so they are UI copy and get translated.
 * Group names and category titles are customer data and are rendered verbatim — see FR-11.
 */

/**
 * @param {Function} t Translation function from withTranslation()
 * @param {string} level A User.USER_ACCESS_RIGHTS value
 * @returns {string}
 */
export function roleLabel(t, level) {
    return t('roles.' + level, { defaultValue: level });
}

/**
 * Re-labels an array of role options, preserving order and each option's `value` index so callers
 * that index into the array keep working. Call this in render(), not in a constructor: a label
 * built in a constructor captures the language at construction time.
 * @param {Function} t Translation function from withTranslation()
 * @param {Array<{value: number, id: string}>} options
 * @returns {Array<{value: number, id: string, label: string}>}
 */
export function withRoleLabels(t, options) {
    if (!Array.isArray(options)) {
        return [];
    }

    return options.map(option => ({ ...option, label: roleLabel(t, option.id) }));
}
